import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import useAxiosPrivate from '../../api/hooks/useAxiosPrivate'
import useToastNotification from '../useToastNotification'
import { SupportReason } from '../../utils/types/supportTypes'

const useFetchSupportReasons = (enabled: boolean) => {
  const axiosPrivate = useAxiosPrivate()
  const { showApiErrorMessage } = useToastNotification()

  const { data, isPending, error } = useQuery({
    queryKey: ['supportReasons'],
    queryFn: async () => {
      const response = await axiosPrivate.get('/api/support-reasons')

      return response.data as SupportReason[]
    },
    retry: 0,
    // The list is an enum on the API - fetch it once and keep it for the session.
    staleTime: Infinity,
    gcTime: Infinity,
    enabled,
  })

  useEffect(() => {
    if (error) {
      showApiErrorMessage(
        error,
        'Something went wrong while loading the support reasons. Please refresh the page and try again.'
      )
    }
  }, [error, showApiErrorMessage])

  return {
    supportReasons: data ?? [],
    isPending: isPending && enabled,
    hasError: error !== null,
  }
}

export default useFetchSupportReasons
